import ChevronRightIcon from '~/components/Icons/svgs/ChevronRightIcon'
import SVGIcon from '~/components/Icons/svgs/SVGIcon'

interface Props {
  expanded: boolean
  color?: string
  size?: number
}

export default function ArrowButton({ expanded, color = 'text-purple', size = 18 }: Props): React.ReactElement {
  const iconRotation = 'rotate-90'
  const iconRotationCollapsed = 'rotate-0'

  return (
    <span
      className={`transform ${expanded ? iconRotation : iconRotationCollapsed} `}
      style={{ transition: 'transform 200ms cubic-bezier(0.4, 0, 1, 1)', display: 'inline-block' }}
    >
      <SVGIcon icon={ChevronRightIcon} pathClassName={color} size={size} />
    </span>
  )
}
